import { render, staticRenderFns } from "./LoansRelatedTable.vue?vue&type=template&id=2bc6ae40&"
import script from "./LoansRelatedTable.vue?vue&type=script&lang=js&"
export * from "./LoansRelatedTable.vue?vue&type=script&lang=js&"
import style0 from "./LoansRelatedTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports